import { render, staticRenderFns } from "./EnrollClu.vue?vue&type=template&id=53ca1105"
import script from "./EnrollClu.vue?vue&type=script&lang=js"
export * from "./EnrollClu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports